const assetModules = import.meta.glob(['../../assets/**/*.jpg', '../../assets/**/*.jpeg', '../../assets/**/*.png', '../../assets/**/*.webp'], {
  eager: true,
  query: '?url',
  import: 'default',
})

const asset = (path) => {
  const url = assetModules[`../../assets/${path}`]

  if (!url) {
    throw new Error(`Missing WebP asset: ${path}`)
  }

  return url
}

export const sceneStyles = [
  {
    id: 'quick',
    name: 'Quick Scene',
    nameZh: '快捷',
    description: 'A clean and efficient room setup with practical bedside additions for fast-turnover hospitality spaces.',
    descriptionZh: '简洁高效的客房陈列，强调落地快、搭配稳，适合标准化出图。',
    promptZh: '整体空间偏标准化快捷酒店风格，构图简洁，床品摆放利落，灯光明亮均匀，画面重点突出产品本身与快速落地的陈列效果。',
    promptEn: 'Use a clean quick-hotel look with efficient composition, bright even lighting, and tidy styling that emphasizes practical bedding presentation.',
    gradient: 'linear-gradient(135deg, #e9eef5 0%, #d7dfeb 40%, #c5d3e1 100%)',
    accent: '#7f97b1',
    thumbnail: asset('场景风格展示/快捷.png'),
    addsBedsideItems: true,
  },
  {
    id: 'business',
    name: 'Business Hotel',
    nameZh: '商务',
    description: 'A premium business-hotel atmosphere inspired by upscale hospitality spaces with restrained luxury and polished layering.',
    descriptionZh: '高端商务酒店氛围，参考万豪、希尔顿这类高级酒店的克制质感与整洁层次。',
    promptZh: '整体空间参考万豪、希尔顿这类高端商务酒店，床品陈列讲究层次与秩序，色调克制高级，灯光柔和，画面呈现高品质酒店客房效果。',
    promptEn: 'Reference premium business hotels like Marriott or Hilton, with polished layering, restrained luxury, soft lighting, and an upscale guest-room presentation.',
    gradient: 'linear-gradient(135deg, #d9d5cf 0%, #bfb6ab 48%, #8f8378 100%)',
    accent: '#7b6c5f',
    thumbnail: asset('场景风格展示/商务.png'),
    addsBedsideItems: true,
  },
  {
    id: 'japanese',
    name: 'Japanese',
    nameZh: '日式',
    description: 'Warm timber tones, calm negative space, and a softly balanced room composition rooted in Japanese hospitality.',
    descriptionZh: '以木色、留白和柔和秩序营造日式酒店氛围，整体更安静、更克制。',
    promptZh: '整体空间采用日式酒店风格，强调木色、留白、低饱和配色和安静秩序，床品铺陈干净平整，氛围温和克制。',
    promptEn: 'Use a Japanese hotel mood with warm timber tones, quiet negative space, low-saturation colors, and calm, precise bedding styling.',
    gradient: 'linear-gradient(135deg, #f3ede2 0%, #dccfb8 45%, #b79d7c 100%)',
    accent: '#9c7f5c',
    thumbnail: asset('场景风格展示/日系.png'),
    addsBedsideItems: false,
    allowsQuietNegativeSpace: true,
  },
  {
    id: 'resort',
    name: 'Resort Hotel',
    nameZh: '度假酒店',
    description: 'An airy resort mood with brighter daylight, softer textures, and a more relaxed vacation-hotel presentation.',
    descriptionZh: '更通透的采光、更轻松的软装氛围，适合度假酒店场景表达。',
    promptZh: '整体空间采用度假酒店风格，采光更通透，配色更轻松，软装氛围更松弛舒展，画面带有舒适度假感与高端酒店质感。',
    promptEn: 'Use a resort-hotel atmosphere with airy daylight, relaxed styling, softer decorative layering, and a comfortable upscale vacation mood.',
    gradient: 'linear-gradient(135deg, #dff2ef 0%, #a7d8ce 48%, #5ea99c 100%)',
    accent: '#4a9588',
    thumbnail: asset('场景风格展示/度假.png'),
    addsBedsideItems: false,
  },
]

export const getSceneStyleById = (styleId) =>
  sceneStyles.find((style) => style.id === styleId)
